module.exports = __webpack_public_path__ + "img/Michael.95586c3b.jpeg";